module.exports = __webpack_public_path__ + "media/images/piscine intérieure-7e4d5cef3328e22def50e5172b924c31.svg";